import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const TermsOfService = () => {
    return (<>
        <Navbar />
        <div className="w-4/5 mx-auto my-12">
            <div className="mt-4">
                <h1 className="text-2xl font-medium">Fishcord Terms of Service</h1>
                <h2 className="text-lg">Last Updated: February 26, 2025</h2>
                <p>Welcome to Fishcord! By using this bot, you agree to the following Terms of Service. If you do not agree with any part of these terms, please refrain from using Fishcord.</p>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">1. Use of the Bot</h2>
                <ul className="list-disc pl-6">
                    <li>Fishcord is provided as-is, with no guarantees of uptime or availability.</li>
                    <li>You must comply with Discord's Terms of Service and Community Guidelines while using Fishcord.</li>
                    <li>You may not use Fishcord for illegal activities, harassment, or any activity that violates Discord's policies.</li>
                    <li>Misuse of the bot, including excessive API requests or attempts to manipulate its functions, may result in restricted access or removal.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">2. Data Collection & Privacy</h2>
                <ul className="list-disc pl-6">
                    <li>Fishcord collects and stores limited data such as Discord user IDs, server IDs, and fishing-related statistics.</li>
                    <li>No personally identifiable information (PII) is collected.</li>
                    <li>Users have the option to upload photos, but it is not mandatory. If a photo is uploaded, it will be securely stored on Google Cloud Storage and will not be publicly accessible.</li>
                    <li>Collected data is used solely for bot functionality and user experience improvements. We do not sell or share user data with third parties.</li>
                    <li>Users may request data deletion by contacting the bot administrator.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">3. User Responsibilities</h2>
                <ul className="list-disc pl-6">
                    <li>You are responsible for how you interact with Fishcord and the data you submit.</li>
                    <li>Any abuse of the bot, including spamming commands or attempting to exploit vulnerabilities, may result in removal from Fishcord.</li>
                    <li>Users should ensure they have proper permissions within their Discord server before adding or using Fishcord.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">4. Limitation of Liability</h2>
                <ul className="list-disc pl-6">
                    <li>Fishcord is provided “as is,” and we are not liable for any losses, damages, or disruptions caused by its use.</li>
                    <li>We do not guarantee error-free performance and are not responsible for technical issues beyond our control.</li>
                    <li>We reserve the right to modify or discontinue the bot at any time without prior notice.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">5. Changes to These Terms</h2>
                <ul className="list-disc pl-6">
                    <li>We may update these Terms of Service at any time. Continued use of Fishcord after changes take effect means you accept the new terms.</li>
                    <li>Major changes will be communicated via an announcement in the official Fishcord Discord server.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">6. Contact Information</h2>
                <p>For any questions regarding these Terms of Service or to request data removal, please get in contact <a className="text-blue-500 underline" href="https://discord.com/invite/BsCvg3Z23k" target="_blank" rel="noopener noreferrer">here</a>.</p>
            </div>
        </div>
        <Footer />
    </>
    );
};